import React from "react";

const Privacy = () => {
  return (
    <div style={{ padding: 30 }}>
      <h1>Privacy Policy</h1>

      <p>
        PrintMyCake collects user information such as name, email, phone number
        and uploaded images for order processing and printing services.
      </p>

      <p>
        Payments are processed through Razorpay. We do not store payment
        information.
      </p>

      <p>
        Uploaded images are used only for printing and order processing.
      </p>

      <p>
        Contact: support@printmycake.com
      </p>
    </div>
  );
};

export default Privacy;